/**
 * A portal router's base: the build's (Vite `base`), without its trailing slash. A testing preview serves each portal
 * under a path beside the staff app (`/portal/`, `/supplier/`; quote-to-invoice-e2e-testing 07 §2); `/` in
 * production, where it changes nothing (undefined).
 */
export function portalBasename(
  baseUrl: string | undefined,
): string | undefined {
  const trimmed = (baseUrl ?? "/").replace(/\/+$/, "");
  return trimmed ? trimmed : undefined;
}
